"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trueDependencies = void 0;

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var trueDependencies = {
  createTrue: _factoriesAny.createTrue
};
exports.trueDependencies = trueDependencies;